/**
 *
 * FlashCardDetail
 *
 */

export default {
  name: 'FlashCardAnswerBtn',

  methods: {
    handleClick() {
      this.$emit('click');
    },
  },
};
